import AxiosInstance from "./api";

export const SalesDetailedLedgerService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/sales-detailed-ledgers/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/sales-detailed-ledgers/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/sales-detailed-ledgers", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/sales-detailed-ledgers/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/sales-detailed-ledgers/" + id);
  },
};
